import { useLocation } from "react-router-dom";

interface PageMeta {
  title: string;
  sub: string;
}

function resolveMeta(pathname: string): PageMeta {
  if (pathname === "/")
    return { title: "My objectives", sub: "2026/7 - Current reporting period" };
  if (pathname === "/team")
    return { title: "Team dashboard", sub: "Exec & CLT - Current reporting period" };
  if (pathname.startsWith("/objectives"))
    return { title: "All objectives", sub: "Global view - filter, sort, export" };
  if (pathname === "/categories")
    return { title: "Categories", sub: "Coverage & gap analysis across the team" };
  if (pathname.startsWith("/category/"))
    return { title: "Category", sub: "Per-category breakdown" };
  if (pathname.startsWith("/person/"))
    return { title: "Person", sub: "Objectives & activity" };
  if (pathname === "/cover")
    return { title: "People I cover", sub: "Colleagues whose objectives you maintain" };
  if (pathname === "/admin")
    return { title: "Admin", sub: "Roster - reporting periods - audit" };
  if (pathname === "/reports")
    return { title: "Reports & export", sub: "Monthly executive summary - printable" };
  if (pathname === "/diag")
    return { title: "Diagnostics", sub: "Session, role, and data-load checks" };
  return { title: "Objectives", sub: "2026/7" };
}

export function TopBar() {
  const { pathname } = useLocation();
  const meta = resolveMeta(pathname);

  return (
    <div className="sticky top-0 z-10 flex items-center gap-[18px] border-b border-rule bg-paper px-9 pt-5 pb-[18px] print:hidden">
      <div className="min-w-0">
        <div className="font-display text-[22px] font-medium tracking-[-0.01em] text-ink truncate">
          {meta.title}
        </div>
        <div className="mt-[3px] font-mono text-[11px] uppercase tracking-[0.12em] text-ink-3">
          {meta.sub}
        </div>
      </div>
      <div className="flex-1" />
      {/* SWA's built-in sign-out endpoint clears the StaticWebAppsAuthCookie
          and redirects back to the configured target. We don't need MSAL here. */}
      <a
        href="/.auth/logout?post_logout_redirect_uri=/"
        className="inline-flex items-center gap-2 rounded-sm border border-rule-strong bg-card px-[14px] py-2 text-[12.5px] font-medium text-ink-2 transition hover:border-ink-3 hover:bg-paper-sunk"
      >
        Sign out
      </a>
    </div>
  );
}
